import React, { Fragment } from 'react';

export const Leaveicon = () => {
    return (
        <Fragment>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.16667 0.5H13.8333C14.7583 0.5 15.5 1.25 15.5 2.16667V3.83333H13.8333V2.16667H2.16667V13.8333H13.8333V12.1667H15.5V13.8333C15.5 14.75 14.7583 15.5 13.8333 15.5H2.16667C1.25 15.5 0.5 14.75 0.5 13.8333V2.16667C0.5 1.25 1.25 0.5 2.16667 0.5Z"
                    fill="#D96367"
                />
                <path
                    d="M11.75 12.1667L10.575 10.9917L12.725 8.83333H4.66667V7.16667H12.725L10.575 5.00833L11.75 3.83333L15.9167 8L11.75 12.1667Z"
                    fill="#D96367"
                />
            </svg>
        </Fragment>
    );
};

export const Globe = () => {
    return (
        <Fragment>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM7.71 17.667C6.72341 15.5743 6.15187 13.3102 6.027 11H2.062C2.25659 12.5389 2.89392 13.9882 3.89657 15.1717C4.89922 16.3552 6.22401 17.2221 7.71 17.667ZM8.03 11C8.181 13.439 8.878 15.73 10 17.752C11.1523 15.6766 11.8254 13.3695 11.97 11H8.03ZM17.938 11H13.973C13.8481 13.3102 13.2766 15.5743 12.29 17.667C13.776 17.2221 15.1008 16.3552 16.1034 15.1717C17.1061 13.9882 17.7434 12.5389 17.938 11ZM2.062 9H6.027C6.15187 6.68979 6.72341 4.42569 7.71 2.333C6.22401 2.77788 4.89922 3.64475 3.89657 4.8283C2.89392 6.01184 2.25659 7.4611 2.062 9ZM8.031 9H11.969C11.8248 6.6306 11.152 4.32353 10 2.248C8.84768 4.32345 8.17456 6.63052 8.03 9H8.031ZM12.29 2.333C13.2766 4.42569 13.8481 6.68979 13.973 9H17.938C17.7434 7.4611 17.1061 6.01184 16.1034 4.8283C15.1008 3.64475 13.776 2.77788 12.29 2.333Z"
                    fill="#6378FF"
                />
            </svg>
        </Fragment>
    );
};

export const Plus = () => {
    return (
        <Fragment>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8 4.75294H4.83137V8H3.16863V4.75294H0V3.24706H3.16863V0H4.83137V3.24706H8V4.75294Z"
                    fill="#1C1B1F"
                />
            </svg>
        </Fragment>
    );
};
export const QUESTION = () => {
    return (
        <Fragment>
            <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="0.5" width="29" height="29" rx="14.5" fill="black" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4273 17.2747C16.4267 17.8199 15.984 18.2626 15.4388 18.2626C14.8937 18.2626 14.4504 17.8199 14.4504 17.2747C14.4452 16.99 14.4423 16.8187 14.4423 16.7556C14.4423 16.1172 14.5482 15.5929 14.7612 15.1791C14.9718 14.7682 15.3937 14.3041 16.0286 13.7873C16.664 13.2734 17.0437 12.936 17.1675 12.7751C17.3596 12.5222 17.4551 12.2426 17.4551 11.9394C17.4551 11.5204 17.2862 11.1593 16.9459 10.8612C16.6085 10.5603 16.1524 10.4104 15.5783 10.4104C15.0245 10.4104 14.5632 10.5684 14.1894 10.882C13.8178 11.1986 13.562 11.6784 13.4225 12.3242C13.36 12.8191 12.9376 13.2016 12.426 13.2016C11.8715 13.2016 11.4219 12.7525 11.4219 12.1981C11.4219 12.1547 11.4242 12.113 11.4294 12.0713C11.4873 11.1459 11.8802 10.3635 12.6106 9.71764C13.3409 9.0712 14.3005 8.75 15.4863 8.75C16.7358 8.75 17.7295 9.07698 18.4673 9.72805C19.2052 10.3791 19.5745 11.1355 19.5745 12.003C19.5745 12.4799 19.4402 12.936 19.1688 13.3631C18.8973 13.7896 18.3198 14.3729 17.4314 15.1108C16.9731 15.4905 16.6883 15.7989 16.5772 16.0304C16.4667 16.2625 16.4169 16.6763 16.4273 17.2747ZM15.4388 19.0022C16.0598 19.0022 16.5627 19.5057 16.5627 20.1261C16.5627 20.7471 16.0598 21.25 15.4388 21.25C14.8179 21.25 14.3149 20.7471 14.3149 20.1261C14.3149 19.5057 14.8179 19.0022 15.4388 19.0022Z"
                    fill="white"
                />
                <rect x="1" y="0.5" width="29" height="29" rx="14.5" stroke="black" />
            </svg>
        </Fragment>
    );
};

export const ROUND_TICK = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
                    fill="#3BBA59"
                />
            </svg>
        </>
    );
};

export const UP_ARROW = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path
                d="M10.4173 2.85592C10.2248 2.67038 9.92029 2.66921 9.72629 2.85327L1.69835 10.47C1.37059 10.781 1.59068 11.3328 2.0425 11.3328H5.79211C6.06825 11.3328 6.29211 11.5566 6.29211 11.8328V16.9805C6.29211 17.2566 6.51597 17.4805 6.79211 17.4805H13.271C13.5472 17.4805 13.771 17.2566 13.771 16.9805V11.8328C13.771 11.5566 13.9949 11.3328 14.271 11.3328L17.976 11.3328C18.426 11.3328 18.647 10.7849 18.323 10.4727L10.4173 2.85592Z"
                fill="#FF7A00"
                stroke="#FF7A00"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export const UP_ARROW_OUTLINE = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M10.4173 2.85201C10.2248 2.66647 9.92029 2.6653 9.72629 2.84936L1.69835 10.4661C1.37059 10.7771 1.59068 11.3289 2.0425 11.3289H5.79211C6.06825 11.3289 6.29211 11.5527 6.29211 11.8289V16.9766C6.29211 17.2527 6.51597 17.4766 6.79211 17.4766H13.271C13.5472 17.4766 13.771 17.2527 13.771 16.9766V11.8289C13.771 11.5527 13.9949 11.3289 14.271 11.3289L17.976 11.3289C18.426 11.3289 18.647 10.781 18.323 10.4688L10.4173 2.85201Z"
                stroke="#FF7A00"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export const ROUND_CHECK = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M10.0013 1.66797C5.4013 1.66797 1.66797 5.4013 1.66797 10.0013C1.66797 14.6013 5.4013 18.3346 10.0013 18.3346C14.6013 18.3346 18.3346 14.6013 18.3346 10.0013C18.3346 5.4013 14.6013 1.66797 10.0013 1.66797ZM8.33464 14.168L4.16797 10.0013L5.34297 8.8263L8.33464 11.8096L14.6596 5.48464L15.8346 6.66797L8.33464 14.168Z"
                fill="white"
            />
        </svg>
    );
};

export const THUMBS_UP_SOLID = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path
                d="M3.60279 7.54688H0.922149C0.500905 7.54688 0.15625 7.89705 0.15625 8.32504V17.5852C0.15625 18.0132 0.500905 18.3633 0.922149 18.3633H3.64109V7.54688H3.60279Z"
                fill="#FF7A00"
            />
            <path
                d="M18.1578 9.4952C18.1578 8.44468 17.277 7.54979 16.2047 7.54979H11.571H11.5327C11.4562 7.54979 11.303 7.51089 11.303 7.51089C11.303 7.51089 11.2264 7.19962 11.8008 6.22692C11.9157 6.03238 12.0689 5.83784 12.2603 5.60439C12.6433 5.09858 13.0645 4.55387 13.2177 3.85352C13.4475 2.84191 13.2943 1.79139 12.8348 0.974321C12.6433 0.663056 12.3369 0.429607 11.954 0.351791C11.571 0.273975 11.1881 0.390699 10.92 0.663056C10.1541 1.3634 9.5797 2.18047 9.12016 2.88082C8.77551 3.42553 8.43085 3.93134 8.00961 4.35933C7.3203 5.05967 6.01827 6.42146 5.25237 7.62761C5.25237 7.62761 5.21408 7.66652 5.17578 7.70543V18.0939C6.20974 18.3273 8.0479 18.6386 9.80947 18.6386C10.0775 18.6386 10.3456 18.6386 10.5754 18.5997C11.0732 18.5608 11.5327 18.483 11.9923 18.4441C12.2603 18.4052 12.5284 18.3663 12.7965 18.3273C13.4475 18.2495 13.9453 18.2495 14.7112 18.2884H14.7495H14.8644C15.4771 18.2884 16.3579 17.7437 16.626 16.8877C16.7026 16.6543 16.8174 16.1874 16.5877 15.6816C17.0855 15.3703 17.4302 14.8256 17.4302 14.2031V14.0474C17.4302 13.7751 17.3919 13.5416 17.277 13.3082C17.6982 12.958 17.928 12.4133 17.928 11.8297V11.7908C17.928 11.4406 17.8514 11.1293 17.6599 10.8181C17.9663 10.4679 18.1578 10.001 18.1578 9.4952Z"
                fill="#FF7A00"
            />
        </svg>
    );
};

export const THUMBS_UP_OUTLINED = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path
                d="M1.37998 8.23672H3.90391V17.8532H1.37998C1.28211 17.8532 1.20407 17.8177 1.15596 17.7751C1.10871 17.7333 1.1 17.6962 1.1 17.675V8.41488C1.1 8.39372 1.10871 8.35656 1.15596 8.31477C1.20407 8.27223 1.28211 8.23672 1.37998 8.23672Z"
                stroke="#FF7A00"
                strokeWidth="1.2"
            />
            <path
                d="M11.6467 7.60073L11.0641 7.74409L11.1501 8.09364L11.499 8.18226L11.6467 7.60073ZM11.6467 7.60073L11.4991 8.18228L11.4992 8.1823L11.4993 8.18234L11.4997 8.18243L11.5006 8.18266L11.503 8.18327L11.5105 8.18513L11.5349 8.19097C11.5546 8.19559 11.5822 8.20182 11.6134 8.20817C11.6585 8.21732 11.7705 8.23964 11.8765 8.23964H11.9148H16.5485C17.2881 8.23964 17.9015 8.86461 17.9015 9.58504C17.9015 9.93856 17.7675 10.2667 17.5521 10.5128L17.2609 10.8457L17.4926 11.2223C17.6202 11.4297 17.6717 11.63 17.6717 11.8806V11.9195C17.6717 12.3503 17.5028 12.7158 17.2372 12.9366L16.8737 13.2388L17.0824 13.663C17.1452 13.7906 17.1739 13.9266 17.1739 14.1373V14.2929C17.1739 14.6866 16.9553 15.0489 16.6133 15.2627L16.1678 15.5412L16.3851 16.0196C16.5217 16.3202 16.4596 16.6077 16.3996 16.7905L16.3996 16.7905L16.3971 16.7983C16.3081 17.0827 16.1101 17.3335 15.8625 17.5158C15.6069 17.7039 15.3553 17.7783 15.2082 17.7783H15.0933H15.0701C14.2946 17.7392 13.762 17.7386 13.069 17.8214L13.0615 17.8223L13.054 17.8234L12.6519 17.8818L12.2672 17.9376C12.0446 17.9569 11.8232 17.9845 11.6111 18.0109C11.5966 18.0127 11.5822 18.0145 11.5679 18.0163C11.3329 18.0456 11.106 18.0731 10.8724 18.0914L10.8455 18.0935L10.8189 18.098C10.6488 18.1268 10.4351 18.1285 10.1532 18.1285C8.68974 18.1285 7.16039 17.9049 6.11953 17.6976V8.01259C6.8491 6.87371 8.09338 5.56866 8.78098 4.87005C9.24862 4.39492 9.6208 3.84467 9.96825 3.29572C10.4212 2.6056 10.9616 1.84222 11.6687 1.19569L11.6803 1.18503L11.6914 1.17378C11.8151 1.04807 11.9914 0.991656 12.1783 1.02962C12.3825 1.07112 12.5504 1.19333 12.6618 1.36942C13.0399 2.04884 13.1738 2.94121 12.9764 3.81047L12.9753 3.81516C12.8557 4.3619 12.5274 4.80151 12.1327 5.32279C11.9451 5.55175 11.7672 5.77579 11.6279 6.01166C11.3222 6.52931 11.171 6.90206 11.1001 7.17032C11.0644 7.3056 11.048 7.41841 11.0442 7.51265C11.0423 7.5599 11.0435 7.60265 11.0472 7.64125C11.049 7.66054 11.0513 7.67875 11.0542 7.69591C11.0556 7.70448 11.0572 7.71278 11.0588 7.72082L11.0614 7.73266L11.0627 7.73843L11.0634 7.74127L11.0638 7.74268C11.0639 7.74339 11.0641 7.74409 11.6467 7.60073Z"
                stroke="#FF7A00"
                strokeWidth="1.2"
            />
        </svg>
    );
};
